<template>
  <el-container class="home-container">
    <!-- 移动端菜单按钮 -->
    <button class="mobile-menu-toggle" @click="toggleMobileMenu" v-if="isMobile">
      <i class="el-icon-s-fold"></i>
    </button>

    <!-- 移动端遮罩层 -->
    <div class="mobile-overlay" :class="{active: mobileMenuOpen}" @click="closeMobileMenu" v-if="isMobile"></div>

    <el-header>
      <div class="header-left" @click="goWelcome">
        <h1 class="system-title">Namzar 后台管理</h1>
        <span v-if="environmentTag" class="env-tag">{{ environmentTag }}</span>
      </div>
      <div class="header-right">
        <div class="user-info">
          <div class="profile-btn" @click="goProfile">
            <i class="el-icon-user"></i> 个人中心
          </div>
          <span class="username">{{ username }}</span>
          <span class="role-tag">{{ role }}</span>
        </div>
        <el-button class="logout-btn" size="small" plain @click="logout">
          <i class="el-icon-switch-button"></i> 退出登录
        </el-button>
      </div>
    </el-header>

    <el-container>
      <el-aside :width="isCollapse ? '64px' : '200px'" :class="{ 'mobile-open': mobileMenuOpen }">
        <div class="toggle-button" @click="toggleCollapse" v-if="!isMobile">
          {{ isCollapse ? '展开' : '折叠' }}
        </div>
        <el-menu
          background-color="#333744"
          text-color="#fff"
          active-text-color="#409eff"
          unique-opened
          :collapse="isCollapse"
          :collapse-transition="false"
          router
          :default-active="activePath"
        >
          <el-menu-item index="/admin/welcome" @click="saveNavState('/admin/welcome')">
            <i class="el-icon-s-home"></i>
            <span slot="title">Home</span>
          </el-menu-item>
          <el-submenu v-for="menu in menuList" :key="menu.id" :index="menu.id">
            <template slot="title">
              <i :class="menu.icon"></i>
              <span>{{ menu.title }}</span>
            </template>
            <template v-for="subMenu in menu.children">
              <el-submenu
                v-if="subMenu.children && subMenu.children.length > 0"
                :key="subMenu.id || subMenu.path"
                :index="subMenu.id || subMenu.path"
              >
                <template slot="title">
                  <i v-if="subMenu.icon" :class="subMenu.icon"></i>
                  <span>{{ subMenu.title }}</span>
                </template>
                <el-menu-item
                  v-for="third in subMenu.children"
                  :key="third.path"
                  :index="third.path"
                  @click="saveNavState(third.path)"
                >
                  <i v-if="third.icon" :class="third.icon"></i>
                  <span slot="title">{{ third.title }}</span>
                </el-menu-item>
              </el-submenu>
              <el-menu-item
                v-else
                :key="subMenu.path"
                :index="subMenu.path"
                @click="saveNavState(subMenu.path)"
              >
                <i v-if="subMenu.icon" :class="subMenu.icon"></i>
                <span slot="title">{{ subMenu.title }}</span>
              </el-menu-item>
            </template>
          </el-submenu>
        </el-menu>
      </el-aside>

      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { removeToken } from '@/utils/auth'

export default {
  name: 'AdminLayout',
  data () {
    return {
      isCollapse: false,
      activePath: '',
      mobileMenuOpen: false,
      username: '管理员',
      role: '超级管理员',
      roleList: [
        { id: 1, name: '超级管理员' },
        { id: 2, name: '管理员' },
        { id: 3, name: '运营' },
        { id: 4, name: '内容' }
      ],
      menus: [
        {
          id: 'namzar',
          title: 'Namzar',
          icon: 'el-icon-collection',
          roles: [1, 2, 3, 4],
          children: [
            {
              path: '/admin/names',
              title: '名字',
              icon: 'el-icon-collection',
              roles: [1, 2, 3, 4]
            },
            {
              path: '/admin/origins',
              title: 'Origin',
              icon: 'el-icon-connection',
              roles: [1, 2, 3, 4]
            },
            {
              path: '/admin/tags',
              title: 'Tag',
              icon: 'el-icon-price-tag',
              roles: [1, 2, 3, 4]
            }
          ]
        },
        {
          id: 'motivo',
          title: 'Motivo',
          icon: 'el-icon-edit-outline',
          roles: [1, 2, 3, 4],
          children: [
            {
              id: 'quotes-lang',
              title: '三种语言内容',
              icon: 'el-icon-document',
              roles: [1, 2, 3, 4],
              children: [
                { path: '/admin/quotes/zh', title: '中文', icon: 'el-icon-document', roles: [1, 2, 3, 4] },
                { path: '/admin/quotes/en', title: 'English', icon: 'el-icon-document', roles: [1, 2, 3, 4] },
                { path: '/admin/quotes/ug', title: 'ئۇيغۇرچە', icon: 'el-icon-document', roles: [1, 2, 3, 4] }
              ]
            },
            {
              path: '/admin/topics',
              title: 'Topics',
              icon: 'el-icon-collection-tag',
              roles: [1, 2, 3, 4]
            },
            {
              path: '/admin/themes',
              title: 'Themes',
              icon: 'el-icon-brush',
              roles: [1, 2, 3, 4]
            }
          ]
        },
        {
          id: 'personnel',
          title: '人员管理',
          icon: 'el-icon-user-solid',
          roles: [1, 2, 3],
          children: [
            {
              path: '/admin/mini-users',
              title: '小程序用户',
              icon: 'el-icon-user',
              roles: [1, 2, 3]
            },
            {
              path: '/admin/admin-users',
              title: '员工管理',
              icon: 'el-icon-user-solid',
              roles: [1, 2]
            }
          ]
        },
        {
          id: 'membership',
          title: '会员管理',
          icon: 'el-icon-tickets',
          roles: [1, 2, 3],
          children: [
            {
              path: '/admin/memberships',
              title: '会员列表',
              icon: 'el-icon-tickets',
              roles: [1, 2, 3]
            },
            {
              path: '/admin/vip-types',
              title: '会员类型',
              icon: 'el-icon-medal',
              roles: [1, 2]
            }
          ]
        },
        {
          id: 'system',
          title: '系统中心',
          icon: 'el-icon-setting',
          roles: [1, 2, 3, 4],
          children: [
            {
              path: '/admin/profile',
              title: '个人中心',
              icon: 'el-icon-s-custom',
              roles: [1, 2, 3, 4]
            }
          ]
        }
      ]
    }
  },
  computed: {
    menuList () {
      const roleId = this.roleList.find(item => item.name === this.role)?.id
      if (!roleId) return []
      return this.menus
        .filter(menu => menu.roles.includes(roleId))
        .map(menu => {
          const children = menu.children
            .filter(child => child.roles.includes(roleId))
            .map(child => {
              if (child.children && child.children.length > 0) {
                return {
                  ...child,
                  children: child.children.filter(third => third.roles.includes(roleId))
                }
              }
              return child
            })
            .filter(child => !(child.children && child.children.length === 0))
          return { ...menu, children }
        })
    },
    environmentTag () {
      if (process.env.NODE_ENV === 'production') return ''
      if (process.env.NODE_ENV === 'development') return '开发环境'
      return '测试环境'
    },
    isMobile () {
      return window.innerWidth <= 768
    }
  },
  created () {
    const cachedPath = window.sessionStorage.getItem('activePath') || '/admin/welcome'
    this.activePath = this.normalizeActivePath(cachedPath)
    this.getUserInfo()
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        if (to.path.startsWith('/admin/')) {
          const normalized = this.normalizeActivePath(to.path)
          this.activePath = normalized
          window.sessionStorage.setItem('activePath', normalized)
        }
      }
    }
  },
  methods: {
    async getUserInfo () {
      const cachedName = localStorage.getItem('namzar-admin-username')
      const cachedRole = localStorage.getItem('namzar-admin-role')
      if (cachedName) this.username = cachedName
      if (cachedRole) this.role = cachedRole
      try {
        const res = await this.request({
          method: 'get',
          url: '/namzar/admin/profile'
        })
        if (res && res.data) {
          this.username = res.data.username || this.username
          const matchRole = this.roleList.find(item => item.id === res.data.role_id)
          if (matchRole) this.role = matchRole.name
        }
      } catch (res) {
        this.$message.error(res?.message || '获取用户信息失败')
      }
    },
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    toggleMobileMenu () {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenu () {
      this.mobileMenuOpen = false
    },
    handleResize () {
      if (window.innerWidth > 768) {
        this.mobileMenuOpen = false
      }
    },
    saveNavState (path) {
      const normalized = this.normalizeActivePath(path)
      this.activePath = normalized
      window.sessionStorage.setItem('activePath', normalized)
    },
    goWelcome () {
      if (this.$route.path !== '/admin/welcome') {
        this.$router.push('/admin/welcome')
      }
    },
    goProfile () {
      if (this.$route.path !== '/admin/profile') {
        this.$router.push('/admin/profile')
      }
    },
    normalizeActivePath (path) {
      if (path.startsWith('/admin/mini-users/')) return '/admin/mini-users'
      if (path.startsWith('/admin/memberships/')) return '/admin/memberships'
      if (path.startsWith('/admin/admin-users/')) return '/admin/admin-users'
      return path
    },
    logout () {
      removeToken()
      this.$message.warning('已退出登录')
      window.sessionStorage.removeItem('activePath')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.home-container {
  height: 100vh;
}

.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,.12);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.system-title {
  font-size: 20px;
  font-weight: 500;
  margin: 0;
}

.env-tag {
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.4);
  font-size: 12px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-info {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  cursor: pointer;
}

.profile-btn {
  position: absolute;
  left: -100px;
  transform: translateX(35px);
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 16px;
  opacity: 0;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.user-info:hover .profile-btn {
  left: -100px;
  opacity: 1;
  transform: translateX(0);
}

.role-tag {
  background: rgba(255,255,255,0.1);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.logout-btn {
  border-color: rgba(255,255,255,0.35);
  color: #fff;
  border-radius: 20px;
  padding: 10px 14px;
  transition: all 0.2s ease;
  background: none;
}

.logout-btn:hover {
  color: #fff !important;
  background: rgba(255,255,255,0.12) !important;
  border-color: rgba(255,255,255,0.35) !important;
}

.el-aside {
  background-color: #333744;
  transition: 0.1s linear;
  overflow: hidden;
}

.el-aside .el-menu {
  border-right: none;
  overflow-y: auto;
  overflow-x: hidden;
}

.el-main {
  background-color: #eaedf1;
  height: calc(100vh - 60px);
  overflow-y: auto;
  padding: 0px;
}

.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 2px;
  cursor: pointer;
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  .el-header {
    padding: 0 8px 0 40px;
    height: 48px !important;
  }

  .system-title {
    font-size: 12px !important;

  }

  .header-left {
    gap: 6px;
  }

  .env-tag {
    font-size: 8px !important;
    padding: 2px 6px;
  }

  .header-right {
    gap: 8px;
  }

  .user-info {
    gap: 4px;
  }

  .username {
    display: none; /* 移动端隐藏用户名 */
  }

  .role-tag {
    font-size: 10px;
    padding: 1px 4px;
  }

  .logout-btn {
    padding: 4px 8px;
    font-size: 11px;
    min-width: auto;
  }

  .profile-btn {
    display: none; /* 移动端隐藏个人中心按钮 */
  }

  .el-aside {
    position: fixed;
    top: 48px;
    left: 0;
    height: calc(100vh - 48px);
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }

  .el-aside.mobile-open {
    transform: translateX(0);
  }

  .el-main {
    height: calc(100vh - 48px);
  }

  .mobile-menu-toggle {
    display: block !important;
    position: fixed;
    top: 8px;
    left: 8px;
    z-index: 1001;
    background: #373d41;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 6px;
    cursor: pointer;
  }

  .mobile-overlay {
    display: block !important;
    position: fixed;
    top: 48px;
    left: 0;
    width: 100%;
    height: calc(100vh - 48px);
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
  }

  .mobile-overlay.active {
    opacity: 1;
    visibility: visible;
  }
}

/* 隐藏移动端不需要的元素 */
.mobile-menu-toggle {
  display: none;
}

.mobile-overlay {
  display: none;
}

@media (max-width: 480px) {
  .el-header {
    height: 45px !important;
  }

  .system-title {
    font-size: 14px;
  }

  .env-tag {
    font-size: 10px;
    padding: 2px 8px;
  }

  .el-aside {
    width: 280px !important;
  }

  .el-main {
    height: calc(100vh - 45px);
  }

  .el-aside {
    top: 45px;
    height: calc(100vh - 45px);
  }

  .mobile-overlay {
    top: 45px;
    height: calc(100vh - 45px);
  }
}
</style>

